<ng-container *transloco="let t">
  <nz-descriptions nzSize="small" [nzColumn]="columns">
    <nz-descriptions-item [nzTitle]="t('type')" [nzSpan]="1">
      {{ fireAlarmComponent?.type }}
    </nz-descriptions-item>
    <nz-descriptions-item [nzTitle]="t('model')" [nzSpan]="1">
      {{ fireAlarmComponent?.model }}
    </nz-descriptions-item>
    <nz-descriptions-item [nzTitle]="t('manufacture')" [nzSpan]="1">
      {{ fireAlarmComponent?.manufacture }}
    </nz-descriptions-item>
  </nz-descriptions>
</ng-container>
